<template>
    <div class="language-switch" style="position: relative; display: inline-block;">
        <div @click.stop="showDropdown = !showDropdown" style="cursor: pointer;" class="d-flex align-items-center">
            <div class="c-avatar" style="width: 33px; height: 33px; flex-shrink: 0;">
                <img :alt="currentLang.name" :src="currentLang.icon" class="icon-lan" />
            </div>
            <span v-if="showName" class="ml-2 text-dark" style="font-size: 14px; white-space: nowrap;">{{ currentLang.name }}</span>
        </div>

        <!-- Dropdown -->
        <div v-if="showDropdown" class="language-dropdown" :class="{ 'dropdown-up': showName }" @click.stop>
            <div
                v-for="lang in enabledLanguages"
                :key="lang.value"
                class="language-item"
                :class="{ 'active': lang.value === $i18n.locale }"
                @click="selectLanguage(lang.value)"
            >
                <img :src="lang.icon" :alt="lang.name" class="language-item-icon" />
                <span class="language-item-name">{{ lang.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import pos from '@/services/pos'

export default {
    props: {
        showName: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDropdown: false,
            enabledLanguages: [],
            allLanguages: [
                { value: 'th', name: 'ไทย', icon: '/img/languages/th.png' },
                { value: 'en', name: 'English', icon: '/img/languages/en.png' },
                { value: 'lo', name: 'ລາວ', icon: '/img/languages/lo.png' },
                { value: 'my', name: 'မြန်မာ', icon: '/img/languages/my.png' },
                { value: 'zh', name: 'Chinese', icon: '/img/languages/flag_China01.png' },
                { value: 'ja', name: '日本語', icon: '/img/languages/flag_JP01.png' },
                { value: 'km', name: 'ភាសាខ្មែរ', icon: '/img/languages/flag_Cambodia01.png' },
                { value: 'ko', name: '한국어', icon: '/img/languages/ko.png' },
                { value: 'hi', name: 'हिन्दी', icon: '/img/languages/flag_India01.png' },
                { value: 'id', name: 'Bahasa Indonesia', icon: '/img/languages/flag_Indo01.png' },
                { value: 'ar', name: 'العربية', icon: '/img/languages/flag_Arab01.png' },
            ]
        }
    },
    computed: {
        currentLang() {
            return this.enabledLanguages.find(l => l.value === this.$i18n.locale) 
                || this.allLanguages.find(l => l.value === this.$i18n.locale)
                || this.allLanguages[0]
        },
        token() {
            return localStorage.getItem('token') || null
        },
        profile() {
            const profile = JSON.parse(localStorage.getItem('profile')) || {}
            return profile
        },
        shopObjectId() {
            return localStorage.getItem('shopObjectId')
        },
        uid() {
            return localStorage.getItem('uid')
        },
        isDelivery() {
            return localStorage.getItem('orderType') == 'delivery'
        }
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown)
        this.loadLanguageConfig()
        // Poll localStorage ทุก 2 วินาที เพราะ Home อาจ set หลัง mount
        this._configInterval = setInterval(() => {
            this.loadLanguageConfig()
        }, 2000)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdown)
        if (this._configInterval) clearInterval(this._configInterval)
    },
    methods: {
        closeDropdown() {
            this.showDropdown = false
        },
        loadLanguageConfig() {
            try {
                const config = JSON.parse(localStorage.getItem('languageConfig'))
                if (config && config.enabledLanguages) {
                    this.enabledLanguages = this.allLanguages.filter(
                        l => config.enabledLanguages[l.value] === true
                    )
                } else {
                    this.enabledLanguages = this.allLanguages.filter(l => ['th', 'en'].includes(l.value))
                }
            } catch {
                this.enabledLanguages = this.allLanguages.filter(l => ['th', 'en'].includes(l.value))
            }
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        selectLanguage(locale) {
            this.$i18n.locale = locale
            this.showDropdown = false
            this.trackButtonClick('home/change_lang_to_' + locale)
            this.updateProfileLanguege()
        },
        async updateProfileLanguege() {
            if (this.isDelivery && this.token) {
                const data = {
                    objectId: this.profile.objectId,
                    language: this.$i18n.locale
                }

                await pos({
                    url: `/api/v1.3/${this.uid}/profile/languege`,
                    method: 'patch',
                    data: data,
                    headers: {
                        authorization: this.token
                    },
                })
            }
        }
    },
}
</script>

<style scoped>
.language-switch {
    display: inline-block;
}

.language-dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    min-width: 160px;
    overflow: hidden;
}

.language-dropdown.dropdown-up {
    top: auto;
    bottom: 40px;
    left: 0;
    right: auto;
}

.language-item {
    display: flex;
    align-items: center;
    padding: 10px 14px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.language-item:hover {
    background-color: #f5f5f5;
}

.language-item.active {
    background-color: #e8f5e9;
}

.language-item-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
}

.language-item-name {
    font-size: 14px;
    color: #333;
}
.icon-lan{
    width: 42px;
    height: 42px;
    border-radius: 50em;
}
</style>
